import React from "react";
export default function SuccessStories() {
  return null;
}